import { render, staticRenderFns } from "./WebPagesProductsForm.vue?vue&type=template&id=792654fc&scoped=true&"
import script from "./WebPagesProductsForm.vue?vue&type=script&lang=js&"
export * from "./WebPagesProductsForm.vue?vue&type=script&lang=js&"
import style0 from "./WebPagesProductsForm.vue?vue&type=style&index=0&id=792654fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792654fc",
  null
  
)

export default component.exports